import { NgModule } from '@angular/core';
import { CommonModule, DatePipe, NgClass, NgFor, NgIf } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule, RouterOutlet } from '@angular/router';




@NgModule({ declarations: [],
    exports: [
        NgClass,
        NgIf,
        NgFor,
        ReactiveFormsModule,
        RouterOutlet,
        RouterModule
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        NgClass,
        NgIf,
        NgFor,
        RouterOutlet,
        RouterModule], providers: [
        DatePipe
    ]
})
export class CommonNgModule { }
